/**
 * Format milliseconds as M:SS (e.g. 83000 -> "1:23").
 */
export function formatTimestamp(ms: number): string {
	const totalSeconds = Math.floor(ms / 1000)
	const minutes = Math.floor(totalSeconds / 60)
	const seconds = totalSeconds % 60
	return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
